<template>
  <div>
    <v-card-title>
      Weekly Timesheet Audit
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card :loading="loading" :disabled="loading" class="audit-body">
      <v-card-title>
        <v-row no-gutters class="align-center flex-nowrap">
          <v-btn icon class="ma-2" @click="onPrevWeekClicked()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <div class="week-title">
            {{ weekTitle() }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon class="ma-2" @click="onNextWeekClicked()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col md="3" sm="4" xs="12" cols="12" v-if="isAdmin">
            <SelectField :items="linemanagers" item-title="FirstName" item-value="id" v-model="selectedLineManager"
              label="Line Manager" outlined dense />
          </v-col>
          <v-col md="3" sm="4" xs="12" cols="12">
            <SelectField :disabled="!filteredCommitments.length" :menu-props="{ bottom: true, offsetY: true }"
              :items="TeamMembers" item-title="TmFullName" item-value="id" v-model="selectedTeamMemberId"
              label="Team Member" placeholder="Team Member" outlined />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mt-3" :loading="loading || tableLoading" :disabled="loading || tableLoading">
      <v-card-text v-if="commitmentsWithRelations.commitments && commitmentsWithRelations.commitments.length">
        <v-data-table :headers="commitmentHeaders" :items="filteredCommitments" :single-expand="true" item-key="id"
          class="elevation-1 custom-table-row">
          <template v-slot:item.actions="{ item }">
            <v-btn class="btn-white" @click="ApproveOrRevokeWeeklyTimesheetAudit(item)" v-if="!isAdmin">
              {{ CheckWeeklyTimesheetAuditNotRevoked(item.id) ? "Revoke Approval" : "Approve" }}
            </v-btn>
            <v-btn :disabled="true" class="btn-white" v-else>
              {{ CheckWeeklyTimesheetAuditNotRevoked(item.id) ? "Approved" : "Not Approved" }}
            </v-btn>
          </template>
          <template v-slot:item.TimeSheetReport="{ item }">
            <v-btn v-tooltip="'Time Sheets Overal Status'" @click="showTeammembersStatusMenu(item.id)" variant="text">
              <v-icon icon="mdi-chart-box"></v-icon>
            </v-btn>
          </template>
          <template v-slot:item.SumTimesheet="{ item }">
            {{ SumTimeSheet(item) }}
          </template>
          <template v-slot:item.SumLeave="{ item }">
            {{ SumLeave(item) }}
          </template>
          <template v-slot:item.SumAdjustment="{ item }">
            {{ SumAdjustment(item) }}
          </template>
          <template v-slot:item.SubTotal="{ item }">
            {{ SubTotal(item) }}
          </template>
          <template v-slot:item.TeamMember="{ item }">
            {{ item.TeamMember && item.TeamMember.TmFullName }}
          </template>

          <template v-slot:expanded-row="{ columns, item }">
            <td :colspan="columns.length" class="data-table-expanded-content custom-timesheet-row pa-2">
              <v-row class="ma-0">
                <v-col xs="2"> Date </v-col>
                <v-col xs="2"> IssueNo </v-col>
                <v-col xs="2"> Project </v-col>
                <v-col xs="2"> Epic </v-col>
                <v-col xs="2"> Activity </v-col>
                <v-col xs="2"> Technology </v-col>
                <v-col xs="2"> Effort </v-col>
                <v-col xs="2"> Adjustment </v-col>
                <v-col xs="2"> Time Sheet Status </v-col>
                <v-col xs="2" class="text-center" v-if="!CheckWeeklyTimesheetAuditNotRevoked(item.id)"> Action </v-col>
              </v-row>
              <div v-for="timesheet in filterTimeSheet(item.id)" :key="timesheet.id" class="timesheet-row"
                v-bind:style="{ background: timesheet.backgroundColor }">
                <v-row class="ma-0">
                  <v-col xs="2">
                    {{ getDateStr(timesheet.Date) }}
                  </v-col>
                  <v-col xs="2">
                    {{ timesheet.IssueNo }}
                  </v-col>
                  <v-col xs="2">
                    {{ timesheet.Project && timesheet.Project.Name }}
                  </v-col>
                  <v-col xs="2">
                    {{ timesheet.Epic }}
                  </v-col>
                  <v-col xs="2">
                    {{ timesheet.Activity }}
                  </v-col>
                  <v-col xs="2">
                    {{ timesheet.Technology }}
                  </v-col>
                  <v-col xs="2">
                    {{ timesheet.Effort }}
                  </v-col>
                  <v-col xs="2">
                    {{ timesheet.Adjustment }}
                  </v-col>
                  <v-col xs="2">
                    <v-chip :color="getLabelColor(timesheet.PredictedLabel)">
                      {{ getTimeSheetLabel(timesheet.PredictedLabel) }}
                    </v-chip>
                  </v-col>
                  <v-col xs="2" class="text-center" v-if="!CheckWeeklyTimesheetAuditNotRevoked(item.id)">
                    <v-menu bottom left>
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props">mdi-dots-vertical</v-icon>
                      </template>
                      <v-list>
                        <v-list-item @click="OnAdjustmentClick(timesheet)" :disabled="timesheet.IsLeave"
                          prepend-icon="mdi-tune" title="Adjustment" />
                        <v-list-item v-if="!isAdmin" @click="OnReactClick(timesheet)" :disabled="timesheet.IsLeave"
                          prepend-icon="mdi-emoticon" title="React" />
                        <v-list-item prepend-icon="mdi-comment-plus" title="Evaluate"
                          @click="timeSheetIdForEvaluation = timesheet.id; openEvaluateTimeSheetDialog = true">
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row class="ma-0 mt-2">
                  <v-col xs="12" class="description"> Description: {{ timesheet.Description }} </v-col>
                </v-row>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog persistent v-if="showAdjustmentDialog" v-model="showAdjustmentDialog"
      @keydown.esc="showAdjustmentDialog = false" max-width="440px">
      <adjustment @cancel="showAdjustmentDialog = false" @saved="updateAdjustment" @errorRaised="errorRaised"
        :isAdmin="isAdmin" :id="selectedTimeSheet.id" :ad="Number(selectedTimeSheet.Adjustment)"></adjustment>
    </v-dialog>
    <v-dialog persistent v-if="showReactionDialog" v-model="showReactionDialog"
      @keydown.esc="showReactionDialog = false" max-width="440px">
      <reaction @cancel="showReactionDialog = false" @saved="updateReaction" @errorRaised="errorRaised"
        @successRaised="successRaised" :timesheetId="selectedTimeSheet.id"></reaction>
    </v-dialog>
    <v-dialog v-if="showRevokeDialog" v-model="showRevokeDialog" max-width="500"
      @keydown.esc="showRevokeDialog = false">
      <confirm-dialog :message="{ title: 'Process Confirmation', text: 'Are you sure you want to Revoke ?' }"
        :showDialog="showRevokeDialog" @cancel="CancelRevokeDialog()" @confirm="ConfirmRevokeDialog()"></confirm-dialog>
    </v-dialog>
    <v-dialog v-if="showApproveDialog" v-model="showApproveDialog" max-width="500"
      @keydown.esc="showApproveDialog = false">
      <confirm-dialog :message="{ title: 'Process Confirmation', text: 'Are you sure you want to Approve ?' }"
        :showDialog="showApproveDialog" @cancel="CancelApproveDialog()"
        @confirm="ConfirmApproveDialog()"></confirm-dialog>
    </v-dialog>
    <v-dialog v-model="openEvaluateTimeSheetDialog" width="auto">
      <EvaluateTimeSheet @close="openEvaluateTimeSheetDialog = false" :timeSheetId="timeSheetIdForEvaluation"
        @errorRaised="errorRaised" @successRaised="successRaised" />
    </v-dialog>
    <v-dialog v-model="showTeammembersStatus" max-width="700">
      <TeammembersStatus @close="showTeammembersStatus = false" :labels-count="labelsCount"/>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Timesheet from "../../models/Timesheet";
import Commitment, { CommitmentMin, TeamMenberOfCommitment } from "../../models/Commitment";
import CommitmentsWithRelations from "../../models/CommitmentWithRelations";
import { mapGetters } from "vuex";
import Leave from "../../models/Leave";
import Utils from "../../utils/Utils";
import CommitmentService from "../../services/CommitmentService";
import WeeklyTimesheetAuditService from "../../services/WeeklyTimesheetAuditService";
import Adjustment from "./Adjustment.vue";
import Reaction from "./Reaction.vue";
import EvaluateTimeSheet from "./EvaluateTimeSheet.vue";
import WeeklyTimesheetAudit from "../../models/WeeklyTimesheetAudit";
import ConfirmDialog from "../ConfirmDialog.vue";
import AppHelper from "../../utils/AppHelper";
import moment from "moment";
import store from "@/store";
import LineManager from "../../models/LineManager";
import LineManagerService from "../../services/LineManagerService";
import TeammembersStatus from "../Project/TeammembersStatus.vue";

export default defineComponent({
  props: {
    isAdmin: {
      required: true,
      type: Boolean,
    },
  },
  components: {
    Adjustment,
    Reaction,
    ConfirmDialog,
    EvaluateTimeSheet,
    TeammembersStatus,
  },
  data() {
    return {
      labelsCount: {} as { [key: number]: number },
      showTeammembersStatus: false,
      openEvaluateTimeSheetDialog: false,
      timeSheetIdForEvaluation: "",
      fetchLoading: false,
      showArrows: false,
      showRemoveConfirm: false,
      showCloneDialog: false,
      isDeleting: false,
      dayOffset: 0,
      showLeaveDialog: false,
      expanded: [],
      showAdjustmentDialog: false,
      showReactionDialog: false,
      selectedTimeSheet: {} as Timesheet,
      commitmentHeaders: [
        { title: "Commitment Name", value: "Name", sortable: false },
        { title: "TM Name", value: "TeamMember", sortable: false },
        { title: "Min Hours", value: "HoursPerWeekMin", sortable: false, align: "center" },
        { title: "Max Hours", value: "HoursPerWeekMax", sortable: false, align: "center" },
        { title: "Timesheet", value: "SumTimesheet", sortable: false, align: "center" },
        { title: "Leave", value: "SumLeave", sortable: false, align: "center" },
        { title: "Adjustment", value: "SumAdjustment", sortable: false, align: "center" },
        { title: "SubTotal", value: "SubTotal", sortable: false, align: "center" },
        { title: "Action", value: "actions", sortable: false, align: "center" },
        { title: "", value: "data-table-expand" },
      ],
      newEventStartHours: [0, 0, 0, 0, 0, 0, 0],
      leaveList: [] as Leave[],
      timesheetList: [] as Timesheet[],
      selectedLeave: null as Leave | null,
      itemRemove: {} as Timesheet,
      dateColors: [],
      selectedTimesheet: {} as Timesheet,
      selectedCommitment: {} as Commitment,
      showRevokeDialog: false,
      showApproveDialog: false,
      commitmentsWithRelations: {} as CommitmentsWithRelations,
      arrowWidths: [] as number[],
      selectedTeamMemberId: "all",
      TeamMembers: [] as TeamMenberOfCommitment[],
      weeklyTimesheetAuditList: [] as WeeklyTimesheetAudit[],
      loading: false,
      tableLoading: false,
      selectedLineManager: "",
      linemanagers: [] as LineManager[],
      groupByDate: {
        "1": [],
        "2": [],
        "3": [],
        "4": [],
        "5": [],
        "6": [],
        "0": [],
      } as { [key: string]: Timesheet[] },
      colors: ["red", "orange"],
      weekday: [1, 2, 3, 4, 5, 6, 0],
      value: "",
      events: [] as any[],
      confirmModel: {
        title: "Remove timesheet",
        text: "Are you sure?",
      },
    };
  },
  async mounted() {
    this.loading = true;
    try
    {
    if (this.isAdmin) {
      this.commitmentHeaders.splice(-2, 0, { title: "TimeSheet Report", value: "TimeSheetReport", sortable: false, align: "center" });
      await this.fetchLinemanagers();
    }
    await this.fetchWeeklyTimeSheetAudits();
    await this.fetchCommitmentsWithRelations();
  }
  finally
  {
    this.loading = false;
  }
  },
  methods: {
    showTeammembersStatusMenu(commitmentId: any) {
      this.commitmentsWithRelations.timesheets.forEach((item) => {
        if (item.CommitmentId === commitmentId && item.Date >= this.startDate && item.Date <= this.endDate) {
          if (this.labelsCount[item.PredictedLabel]) {
            this.labelsCount[item.PredictedLabel]++;
          } else {
            this.labelsCount[item.PredictedLabel] = 1;
          }
        }
      });
      this.showTeammembersStatus = true;
    },
    getLabelColor(Status: any) {
      if (Status == 3) return "red";
      else if (Status == 2) return "orange";
      else if (Status == 1) return "green";
      else return "gray";
    },
    getTimeSheetLabel(Status: any) {
      if (Status == 3) return "B";
      else if (Status == 2) return "M";
      else if (Status == 1) return "E";
      else return "N";
    },
    async fetchLinemanagers() {
      
        LineManagerService.getList(true)
          .then((items: any) => {
            this.linemanagers = items
              .filter((c: any) => c.FirstName && c.FirstName.trim() && c.LastName && c.LastName.trim())
              .map((item: any) => {
                item.FirstName = `${item.FirstName} ${item.LastName}`;
                return item;
              });
            this.linemanagers.splice(0, 0, { id: "", FirstName: "All" } as LineManager);
          })               
    },
    getDateStr(value: Date | undefined) {
      if (!value) {
        return "";
      }
      return value.toDateString();
    },
    errorRaised(msg: string): void {
      store.dispatch("showErrorMessage", msg);
    },
    successRaised(msg: string): void {
      store.dispatch("showSuccessMessage", msg);
    },
    CancelApproveDialog() {
      this.showApproveDialog = false;
      this.tableLoading = false;
    },
    CancelRevokeDialog() {
      this.showRevokeDialog = false;
      this.tableLoading = false;
    },
    ConfirmRevokeDialog() {
      this.showRevokeDialog = false;
      let wtaExist = this.weeklyTimesheetAuditList.find((wta) => wta.CommitmentID == this.selectedCommitment.id);
      let wtaIndex = this.weeklyTimesheetAuditList.indexOf(wtaExist as WeeklyTimesheetAudit);
      WeeklyTimesheetAuditService.revoke(wtaExist?.id ?? "")
        .then((response) => {
          this.weeklyTimesheetAuditList[wtaIndex].Revoked = true;
          this.tableLoading = false;
        })       
        .finally(() => {
          this.tableLoading = false;
        });
    },
    ConfirmApproveDialog() {
      this.showApproveDialog = false;
      let wtaExist = this.weeklyTimesheetAuditList.find((wta) => wta.CommitmentID == this.selectedCommitment.id);
      let startDate = new Date(this.startDate.toDateString());
      WeeklyTimesheetAuditService.create({
        ApprovedBy: store.state.userInfo.email,
        ApprovedOn: new Date(),
        CommitmentID: this.selectedCommitment.id,
        Revoked: false,
        SumOfHours: Number(this.SumTimeSheet(this.selectedCommitment)),
        WeekStartDate: startDate,
        id: wtaExist != undefined ? wtaExist.id : null,
      } as WeeklyTimesheetAudit)
        .then((response) => {
          this.tableLoading = false;
          if (wtaExist != undefined) {
            this.weeklyTimesheetAuditList[this.weeklyTimesheetAuditList.indexOf(wtaExist as WeeklyTimesheetAudit)].Revoked = false;
          } else {
            if (response) this.weeklyTimesheetAuditList.push(response);
          }
        })        
        .finally(() => {
          this.tableLoading = false;
        });
    },
    async fetchWeeklyTimeSheetAudits() {
      await WeeklyTimesheetAuditService.getList(this.startDate, this.endDate).then(
        (response) => {
          this.weeklyTimesheetAuditList = [];
          this.weeklyTimesheetAuditList = response;
        }       
      );
    },
    fetchTeammembers() {
      this.TeamMembers = [];
      this.TeamMembers.push({ id: "all", TmFullName: "All" });
      this.commitmentsWithRelations.commitments.forEach((commitment) => {
        if (commitment.TeamMember && !this.TeamMembers.some((x) => x.id === commitment.TeamMember.id)) {
          this.TeamMembers.push({ id: commitment.TeamMember.id, TmFullName: commitment.TeamMember.TmFullName });
        }
      });
    },
    async fetchCommitmentsWithRelations() {
      try
      {
      this.tableLoading = true;
      this.loading = true;
      const fromDate = Utils.addTimezoneOffsetToStartDate(this.startDate);
      const toDate = Utils.addTimezoneOffsetToEndDate(this.endDate);
      let dateRange = { StartDate: fromDate, EndDate: toDate };
      if (!this.isAdmin) {
        this.commitmentsWithRelations = await CommitmentService.getCommitmentsAndRelationsByDateRange(dateRange);
      } else {
        this.commitmentsWithRelations = await CommitmentService.getCommitmentsAndRelationsByLinemanagerIdAndDateRange(
          this.selectedLineManager,
          dateRange
        );
      }
      this.fetchTeammembers();
    }
    finally{
      this.tableLoading = false;
      this.loading = false;
    }
    },
    CheckWeeklyTimesheetAuditNotRevoked(id: any): boolean {
      return this.weeklyTimesheetAuditList.find((item) => item.CommitmentID == id && item.Revoked == false) != undefined ? true : false;
    },
    OnAdjustmentClick(timesheet: any) {
      if (!timesheet.IsLeave) {
        this.selectedTimeSheet = timesheet;
        this.showAdjustmentDialog = true;
      }
    },
    OnReactClick(timesheet: any) {
      this.selectedTimeSheet = timesheet;
      this.showReactionDialog = true;
    },
    updateAdjustment(adjustment: number) {
      let index = this.commitmentsWithRelations.timesheets.indexOf(this.selectedTimeSheet);
      this.commitmentsWithRelations.timesheets[index].Adjustment = adjustment;
      this.showAdjustmentDialog = false;
    },
    updateReaction() {
      this.showReactionDialog = false;
    },
    SumTimeSheet(item: any) {
      let sum = 0;
      this.filterTimeSheet(item.id).forEach((item) => (sum += item.IsLeave ? 0 : item.Effort));
      return sum;
    },
    SumLeave(item: any) {
      let sum = 0;
      this.filterTimeSheet(item.id).forEach((item) => (sum += item.IsLeave ? item.Effort : 0));
      return sum;
    },
    SumAdjustment(item: any) {
      let sum = 0;
      this.filterTimeSheet(item.id).forEach((item) => (sum += item.IsLeave ? 0 : Number(item.Adjustment)));
      return sum;
    },
    SubTotal(item: any) {
      let sum = 0;
      this.filterTimeSheet(item.id).forEach((item) => (sum += item.Effort + (item.IsLeave ? 0 : Number(item.Adjustment))));
      return sum;
    },
    ApproveOrRevokeWeeklyTimesheetAudit(item: any) {
      try
      {
      this.tableLoading = true;
      this.selectedCommitment = item;
      if (this.CheckWeeklyTimesheetAuditNotRevoked(item.id)) {
        this.showRevokeDialog = true;
      } else {
        this.showApproveDialog = true;
      }
    }
    finally
    {
      this.tableLoading = false;
    }
    },
    decimalCount(num: any) {
      const numStr = String(num);
      if (numStr.includes(".")) {
        return numStr.split(".")[1].length;
      }
      return 0;
    },
    filterTimeSheet(commitmentId: any): any[] {
      let timesheetAndLeaves: any[] = this.commitmentsWithRelations.timesheets.filter((item) => {
        return item.CommitmentId == commitmentId && item.Date && item.Date >= this.startDate && item.Date <= this.endDate;
      });
      let mappedLeaves = this.commitmentsWithRelations.leaves
        .filter((item) => {
          return item.CommitmentId == commitmentId && item.Date && item.Date >= this.startDate && item.Date <= this.endDate;
        })
        .map((item) => ({
          Date: item.Date,
          IssueNo: "Leave",
          Project: "-",
          Epic: "-",
          Activity: "-",
          Technology: "-",
          Effort: item.Hours,
          Adjustment: 0,
          IsLeave: true,
          Description: item.Description.length > 0 ? item.Description : "-",
        }));
      mappedLeaves.forEach((item) => timesheetAndLeaves.push(item));
      timesheetAndLeaves.sort((a, b) => {
        return a.Date - b.Date;
      });
      timesheetAndLeaves = AppHelper.getListItemColorByDate(timesheetAndLeaves);
      return timesheetAndLeaves;
    },
    removeDecimals(value: any) {
      if (this.decimalCount(value) > 1 && value !== 0) {
        return Number(value.toFixed(1));
      }
      return value;
    },
    onNextWeekClicked() {
      this.events = [];
      this.groupByDate = {
        "1": [],
        "2": [],
        "3": [],
        "4": [],
        "5": [],
        "6": [],
        "0": [],
      };
      this.goNextWeek();
    },
    onPrevWeekClicked() {
      this.events = [];
      this.groupByDate = {
        "1": [],
        "2": [],
        "3": [],
        "4": [],
        "5": [],
        "6": [],
        "0": [],
      };
      this.goPrevWeek();
    },
    async goNextWeek() {
      try
      {
      this.tableLoading = true;
      this.loading = true;
      this.dayOffset++;
      this.newEventStartHours = [0, 0, 0, 0, 0, 0, 0];
      await this.fetchWeeklyTimeSheetAudits();
      await this.fetchCommitmentsWithRelations();
      }
      finally
      {
        this.tableLoading = false;
        this.loading = false;
      }
    },
    async goPrevWeek() {
      try
      {
      this.tableLoading = true;
      this.loading = true;
      this.dayOffset--;
      this.newEventStartHours = [0, 0, 0, 0, 0, 0, 0];
      await this.fetchWeeklyTimeSheetAudits();
      await this.fetchCommitmentsWithRelations();
      }
      finally
      {
        this.tableLoading = false;
        this.loading = false;
      }
    },
    weekTitle(): string {
      return `${Utils.toVsDateFormat(this.startDate).replace(/-/gi, "/")} - ${Utils.toVsDateFormat(this.endDate).replace(/-/gi, "/")}`;
    },
    hoursOfCommitment(commitmentId: string, day?: number): number {
      let retVal = 0;
      if (day || day === 0) {
        const timesheets = this.groupByDate[day];
        timesheets.filter((x) => x.CommitmentId === commitmentId).forEach((x) => (retVal += x.Effort));
        return retVal;
      } else {
        this.timesheetList
          .filter((x) => x.CommitmentId === commitmentId && x.Date && x.Date >= this.startDate && x.Date <= this.endDate)
          .forEach((x) => (retVal += x.Effort));
        return retVal;
      }
    },
  },
  watch: {
    async selectedLineManager(newVal) {
      this.selectedTeamMemberId = "all";
      await this.fetchCommitmentsWithRelations();
    },
  },
  computed: {
    ...mapGetters({ userInfo: "userInfo" }),
    startDate(): Date {
      const startDate = moment().subtract(1, "weeks").startOf("week").toDate();
      startDate.setHours(0, 0, 0, 0);
      startDate.setDate(startDate.getDate() + this.dayOffset * 7);
      return startDate;
    },
    endDate(): Date {
      const retVal = new Date(this.startDate.toString());
      retVal.setDate(retVal.getDate() + 6);
      return retVal;
    },

    filteredCommitments(): CommitmentMin[] {
      let teamMemberId = this.selectedTeamMemberId;
      if (this.commitmentsWithRelations.commitments) {
        return this.commitmentsWithRelations.commitments
          .filter((item) => {
            return teamMemberId == "all" || (item.TeamMember && item.TeamMember.id === teamMemberId);
          })
          .sort((a, b) => this.SumTimeSheet(b) - this.SumTimeSheet(a));
      } else {
        return [];
      }
    },
    listOfZeroCommitments(): CommitmentMin[] {
      return this.commitmentsWithRelations.commitments.filter((c) => this.hoursOfCommitment(c.id) === 0);
    },
    totalWeekHours(): number {
      let retVal = 0;
      this.timesheetList
        .filter((x) => x.Date && x.Date >= this.startDate && x.Date <= this.endDate)
        .forEach((item) => {
          retVal += item.Effort;
        });
      return retVal;
    },
  },
});
</script>
<style lang="scss">
.custom-table-row {
  background-color: red;
}

.custom-timesheet-row {
  min-width: 935px;

  .col {
    overflow-wrap: anywhere;
    text-align: center;
    padding: 0 8px;
  }

  .timesheet-row {
    border: 1px solid #959595;
    border-radius: 10px;
    padding: 10px 0;
    margin: 10px 0;

    .description {
      text-align: left;
      margin: 0 20px;
    }
  }
}
</style>
<style lang="scss" scoped>
.week-title {
  text-wrap: balance;
  text-align: center;
}

.mt-2 {
  margin: 5px 0;
}

.btn-white {
  background-color: #fff !important;
  color: #000 !important;
}

.day-label-header.present {
  font-weight: 700;
}

@media (max-width: 577px) {
  .audit-body {
    margin-top: 50px;
  }

  .action-btn {
    margin-top: 15px;
    width: 100%;
  }
}

@media (max-width: 425px) {
  .week-title {
    font-size: 16px;
  }
}
</style>

<style scoped lang="scss">
.week-statistic {
  display: flex;

  .commitment-names {
    padding-right: 10px;

    .commitment-item {
      &:nth-child(2) {
        margin-top: 54px;
      }

      &.commitment-total {
        justify-content: center;
        color: white;
        font-size: 17px;
        font-weight: 700;
      }

      height: 46px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}

.chart-container {
  flex-grow: 1;

  .chart {
    display: flex;
    height: 5px;

    &--show-percent {
      height: 22px;
      text-align: center;
    }

    .chart-item--arrow {
      display: flex;
      position: absolute;
      top: 0;
      left: 0;

      &.chart-item--zero {
        right: 0;
      }

      .arrow-item {
        height: 100%;
        width: 50%;
        border-right: 1px solid;
        border-bottom: 1px solid;

        &.red-border {
          border-color: #dc1e28;
        }

        &.orange-border {
          border-color: #ff9800;
        }

        .hours {
          position: absolute;
          bottom: 0;
        }
      }
    }
  }

  .chart--arrow {
    position: relative;
  }
}
</style>
